import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-67" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" data-id="element-68" data-mp="32nukolv2nz0b">
        <p className="font-display text-xl font-black text-plum" data-id="element-69" data-mp="32pfc42m3b1ty">
          THE K-SMART VISUAL SYSTEM<span className="align-super text-xs" data-id="element-70" data-mp="36pzb7bq84fiq">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-71" data-mp="3ueih5klswg7n">
          The visual method to learn Korean from absolute zero: Hangul, pronunciation, real phrases
          and K-Drama / K-Pop expressions in 30 days. Because loving Korean culture should not mean
          depending on subtitles forever.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-72" data-mp="3qbvqhn0v91c1">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-73" data-mp="2a19u3nmf7qxt">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-74" data-mp="3l9shv2i5sonf" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-75" data-mp="3gca7r8seo3du">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-76" data-mp="3v5dhitzr9cu0" /> @sigmasmart.en
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="3qaq0thaztmpz">
            <GlobeIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="32w45wy0ricd" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-79" data-mp="hrifzooftryu">
          🌸 “안녕하세요 — your first Korean word starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-80" data-mp="qt8ibpjuybbe">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-81" data-mp="ms6gr22gxn69">
            Terms & Conditions
          </a>
          <span data-id="element-82" data-mp="tw5xc3eitkl5">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="twxv9kvlbuel">
            Privacy Policy
          </a>
          <span data-id="element-84" data-mp="13taokhn8468t">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="13t0v2k2yzgyd">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-86" data-mp="18lbulltst0qe">
          © 2026 THE K-SMART VISUAL SYSTEM™ — SIGMA SMART™ — All rights reserved. Reproduction and
          redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}